import React from 'react';

// Divider Component
const Divider = ({ style, className }) => {
  return (
    <hr
      className={className}
      style={{
        border: 'none',
        borderTop: '2px solid gray',
        margin: '10px 0',
        ...style
      }}
    />
  );
};

export default Divider;
